import React from "react";
import { dateFormatterUI4 } from "../../../../../utils/helpers/dataHelper";
import parse from "html-react-parser";

export default function AnnouncementCard({ item, handleClick }) {
  return (
    <div
      className="rounded m-4 cursor-pointer"
      onClick={() => handleClick(item)}
    >
      <div className="flex justify-center">
        <img
          src={item.imageUrl}
          alt="splash4"
          className={`object-fill w-full h-32 md:h-80 lg:80 max-h-80`}
        />
      </div>
      <div className="text-cente py-4">
        <div className="text-lg single_line font-bold mb-2">{item.title}</div>
        <div className="text-md two_line mb-2">
          {parse(item?.description === undefined ? "" : item.description)}
        </div>
        <div className="mb-2 text-gray-500 text-sm">
          {dateFormatterUI4(item.dateCreated)}
        </div>
        <div className="mt-5 text-gray-500 text-sm cursor-pointer hover:underline">
          Read More
        </div>
        {/* <button
          className="mt-2 bg-green-800 py-2 px-5 rounded text-white"
          onClick={() => handleClick(item)}
        >
          Read More
        </button> */}
      </div>
    </div>
  );
}
